import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CbjDatatableComponent } from './cbj-datatable.component';
import { CbjScrollModule } from '../scroll/index';
import { CbjMenuModule } from '../menu/index';
import { CbjCompCellDirective } from './cbj-component-cell.directive';
import { CbjLinkCellComponent } from './cbj-link-cell.component';
export class CbjDatatableModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    RouterModule,
    CbjMenuModule,
    CbjScrollModule
  ],
  declarations: [
    CbjDatatableComponent,
    CbjCompCellDirective,
    CbjLinkCellComponent
  ],
  exports: [
    CbjDatatableComponent,
    CbjLinkCellComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CbjDatatableModule_tsickle_Closure_declarations() {
/** @type {?} */
CbjDatatableModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjDatatableModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
